import { SVGProps } from 'react';

const ScissorsLineDashed = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M5.42 9.42 8 12m6-6-8.58 8.58m5.38.22L14 18m2-6h-2m8 0h-2M6 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0m0 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
    />
  </svg>
);
export default ScissorsLineDashed;
